import Vue from 'vue';
export default Vue.extend({
    name: 'CommonLabel',
    props: {
        validator: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        hint: {
            type: String,
            required: false
        },
        mandatory: {
            type: Boolean,
            required: false,
            default: false
        },
        requiredMark: {
            type: String,
            required: false,
            default: '*'
        },
        optionalMark: {
            type: String,
            required: false,
            default: '(Optional)'
        }
    },
    setup(props) {
        const labelMark = props.mandatory
            ? `<span class="required-mark">${props.requiredMark}</span>`
            : `<span class="optional-mark">${props.optionalMark}</span>`;
        return {
            labelMark
        };
    }
});
